import { observer } from "mobx-react-lite";
import React from "react";
import styled from "@emotion/styled";
import { StudentSessionLegacyFormView } from "Views/Shared/Views/StudentSessionLegacyForm/StudentSessionLegacyFormView";
import { IStudentSessionReportViewModel } from "Views/Students/Student/StudentReports/Form/Interfaces/IStudentSessionReportViewModel";
import { StudentTargetView } from "Views/Shared/Views/StudentTarget/StudentTargetView";
import { Box, Label, theme } from "Application";

const Container = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    row-gap: 10px;
`;

export const SessionReportTargets: React.FC<{ viewModel: IStudentSessionReportViewModel }> = observer(({ viewModel }) => {
    const viewModels = viewModel.studentTargetViewModels;
    const studentSessionLegacyFormViewModel = viewModel.studentSessionLegacyFormViewModel;
    const isLegacy = studentSessionLegacyFormViewModel?.model.sessionReportModel.isLegacy;
    const showLegacyForm = isLegacy && studentSessionLegacyFormViewModel;
    const showNewForm = !showLegacyForm;
    const noTargetsToDisplay = viewModels.length === 0;

    return (
        <Box borderTop="1px solid #D4D4D4" pt={"25px"} gap="20px">
            <Container>
                <Label fontStyle="h2">Student Targets</Label>
                {noTargetsToDisplay && <Label fontStyle="p">No targets yet.</Label>}
                {showNewForm && viewModels.map((vm) => <StudentTargetView viewModel={vm} key={vm.model.KEY} />)}
                {showLegacyForm && studentSessionLegacyFormViewModel && <StudentSessionLegacyFormView viewModel={studentSessionLegacyFormViewModel} />}
            </Container>
        </Box>
    );
});
